import React from "react"
import { createPortal } from "react-dom"
import PropTypes from "prop-types"
import { isset } from "../../utils/validate"
import { Root, ModalDialog, TitleSection, CloseBtn } from "./popup-modal-base.styles"
import usePortal from "./portal"

const PopupModalBase = ({ id, expand, show, children, titleString, onCloseClick, className }) => {
  if (!show) return null
  const target = usePortal(id)
  const showTitle = isset(titleString) && titleString.length > 0
  return createPortal(
    <Root>
      <ModalDialog mobileFullWidth={showTitle} expand={expand} className={className}>
        <CloseBtn onClick={onCloseClick} />
        {showTitle && <TitleSection>{titleString}</TitleSection>}
        {children}
      </ModalDialog>
    </Root>,
    target
  )
}

PopupModalBase.propTypes = {
  show: PropTypes.bool.isRequired,
  titleString: PropTypes.string,
  onCloseClick: PropTypes.func
}

PopupModalBase.defaultProps = {
  titleString: "",
  onCloseClick: () => {}
}

export default PopupModalBase
